
import jsonQuery from 'json-query'
import _ from '@/utils/lodash-optimized'
import { createRef, Component } from 'react'

import { Nucc, USStateCodes, ContactPointCodes } from '../../../../../../lib/Codes'
import { capitalizeSentence } from '../../../../../../lib/Form'
import {
  bindTargetMixin,
  CancelButton,
  mapCodeForSelect,
  MaskedTextInput,
  NPIOrganizationAutoCompleteSelect,
  QuestionRadioButtonInput,
  SaveButton,
  SelectInput,
  AutoCompleteInput,
  TextInput,
  Validators
} from '../../../../../shared/FormBuilder'
import {
  CircularProgress,
  Paper,
  RequiredSpan
} from '../../../../../shared/NarusMaterial'

class OrganizationForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.handleOrganizationSelect = this.handleOrganizationSelect.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.npiPractitionerName = createRef()
  }

  getValue () {
    return { ...this.state.value }
  }

  componentDidMount () {
    const value = this.getValue()
    this.setState({
      isSubmitting: false,
      reRender: true,
      value
    })
  }

  handleSubmit () {
    const { onSubmit } = this.props

    this.setState({ isSubmitting: true })
    onSubmit(this.getValue())
  }

  handleOrganizationSelect (organization) {
    const jq = jsonQuery
    const q = query => jq(query, { data: organization }).value

    const type = q('type.coding[0].code')
    const zip = q('address[0].postalCode')

    this.setInputValue('.name', capitalizeSentence(q('name')))
    this.setInputValue('.type', type)
    this.setInputValue('.npi', q('id'))
    this.setInputValue('.phone', q('telecom[system=phone].value'))
    this.setInputValue('.phoneType', q('telecom[system=phone].use'))
    this.setInputValue('.fax', q('telecom[system=fax].value'))
    this.setInputValue('.email', q('telecom[system=email].value'))
    this.setInputValue('.address1', q('address[0].line[0]'))
    this.setInputValue('.address2', q('address[0].line[1]'))
    this.setInputValue(
      '.city',
        capitalizeSentence(organization?.address?.[0]?.city)
    )
      this.setInputValue('.state', organization?.address?.[0]?.state)
    this.setInputValue('.zip', zip ? zip.substr(0, 5) : undefined)
  }

  render () {
    const { onCancel } = this.props

    const { name, npi = null } = this.getValue()

    const disableSave = _.isEmpty(name)
    const disableEdit = npi && npi.length > 0

    const yesNoOptions = [
      {
        label: 'Yes',
        value: 'yes'
      },
      {
        label: 'No',
        value: 'no'
      }
    ]

    if (!this.state.reRender) {
      return <CircularProgress />
    }
    return (
      <button
        onKeyDown={this.props.onKeyDown}
        className='form-section'
      >
        <div className='nh-margin-bottom-2'>
          <Paper>
            <h2
              style={{
                margin: '0',
                marginLeft: '1rem'
              }}
            >
              NPI Registry Search
            </h2>

            <NPIOrganizationAutoCompleteSelect
              ref={this.npiPractitionerName}
              onChange={this.handleOrganizationSelect}
              label='Search by Name, Address, and City'
            />
          </Paper>
        </div>

        <Paper>
          <div className='row'>
            <div className='col-xs-12 col-sm-2 col-md-2'>
              <TextInput
                label='NPI ID'
                name='npi'
                disabled
              />
            </div>

            <div className='col-xs-12 col-sm-4 col-md-4'>
              <AutoCompleteInput
                label='Type'
                disabled={disableEdit}
                name='type'
                options={mapCodeForSelect(Nucc)}
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-6'>
              <TextInput
                disabled={disableEdit}
                label='Name'
                name='name'
              />
              <RequiredSpan />
            </div>

            <div className='col-xs-12 col-sm-12 col-md-12 margin-top'>
              <QuestionRadioButtonInput
                name='preferred'
                question='Preferred?'
                options={yesNoOptions}
                disabled={this.props.noPref}
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Address 1'
                name='address1'
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Address 2'
                name='address2'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='City'
                name='city'
              />
            </div>

            <div className='bottom-xs col-xs-12 col-sm-6 col-md-4'>
              <SelectInput
                label='State'
                name='state'
                options={mapCodeForSelect(USStateCodes)}
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <MaskedTextInput
                mask='11111'
                name='zip'
                label='Zip'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-6'>
              <SelectInput
                name='phoneType'
                label='Phone Type'
                options={mapCodeForSelect(ContactPointCodes.contactPointUse)}
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-6'>
              <MaskedTextInput
                mask='111.111.1111'
                name='phone'
                label='Phone Number'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-6'>
              <MaskedTextInput
                mask='111.111.1111'
                name='fax'
                label='Fax Number'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-6'>
              <TextInput
                name='email'
                label='Email'
                validators={[ Validators.email() ]}
              />
            </div>
          </div>

          <div className='row'>
            <h2 style={{ marginLeft: '16px' }}>Notes</h2>
            <div className='col-xs-12 col-sm-12 col-md-12'>
              <TextInput
                name='notes'
                label='Notes'
              />
            </div>
          </div>

          <div
            className='row end-xs'
            style={{ marginTop: '20px' }}
          >
            <div className='col-xs-12'>
              <CancelButton
                noGlobal
                disabled={this.state.isSubmitting}
                onClick={onCancel}
              />
              <SaveButton
                disabled={this.state.isSubmitting || disableSave}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </button>
    )
  }
}

export default OrganizationForm
